var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6426 56.0152V55.2519H55.0734V47.8174H55.8362V56.0152H47.6426Z",
    fill: "#2965FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000455856 47.8193L0.763677 47.8193L0.763677 55.2501L8.19824 55.2501L8.19824 56.013L0.000455498 56.013L0.000455856 47.8193Z",
    fill: "#2965FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8362 8.19768H55.0734V0.763113H47.6426V0H55.8362V8.19768Z",
    fill: "#2965FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21306 0V0.763003H0.78226V8.19757H0.0195312V0H8.21306Z",
    fill: "#2965FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6152 44.6977V40.2164L23.6095 40.2218H25.8373V37.9781H23.6095L23.6152 37.983C23.6129 37.2356 23.6109 36.488 23.6091 35.7401H28.0973V33.5139H30.3304V35.7302H32.5687V31.2634L32.5631 31.2687C32.6579 31.2687 32.7528 31.2656 32.8472 31.2656L39.2824 31.2622V33.4911H41.5048V31.2679H39.2774V29.0178H34.7969V24.5631H28.0817V26.7954H23.6247V31.2755H25.8403V33.5097H23.6145V35.7481H21.3783V33.5048H14.667V31.2729H21.3673V13.3618H23.6145L23.6091 13.3564C23.6091 15.5113 23.6102 17.6664 23.6122 19.8215V20.0602H25.8483V15.607H28.0806V20.0769H30.3296L30.3243 20.0715V22.3076H41.512V24.5411H43.7546V26.7912L43.7603 26.7863H41.5325V29.0299H43.7603L43.7546 29.0246V33.507H45.9983L45.993 33.5017V37.9724H43.7701V42.4605H45.9983L45.993 42.4552V44.6936H50.4625V46.9274H43.7622V51.4041H41.5276V49.1729H37.0402L37.0455 49.1783V46.9399H34.8124V44.7057H39.2683V42.4673H28.0973V44.6924H23.6099L23.6152 44.6977ZM37.0402 37.9826V35.7549H34.8181V37.9785H37.0459V40.2062H41.5052V37.9838L37.0402 37.9826ZM32.5574 37.9933H30.3425V40.2073H32.5574V37.9933ZM37.0508 26.7753H39.2657V24.5604H37.0508V26.7753Z",
    fill: "#2965FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.47559 20.0601V4.41504H19.1207V20.0601H3.47559ZM5.7189 6.6534V17.8202H16.8877V6.6534H5.7189Z",
    fill: "#2965FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.4612 20.065H34.8164V4.41992H50.4612V20.065ZM48.2281 6.65677H37.0597V17.8243H48.2281V6.65677Z",
    fill: "#2965FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.47949 35.752H19.125V51.397H3.47949V35.752ZM16.8878 37.9953H5.71977V49.1636H16.8878V37.9953Z",
    fill: "#2965FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6142 13.361V8.88429H21.3838V4.41895H32.5533V8.87519H30.3415V11.1166H32.556V15.5823H30.329V13.3618H28.0944V11.1295H25.8587V13.355H23.6089L23.6142 13.361ZM25.8587 8.8676H28.0731V6.65276H25.8587V8.8676Z",
    fill: "#2965FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6555 24.5479V26.7862H19.1255V29.0204H12.4244V33.4971H3.48145V29.0394H5.6982V31.25H10.1852V24.5479L10.1795 24.5532H14.6608L14.6555 24.5479Z",
    fill: "#2965FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6084 44.6924V46.9307H25.8426V49.1649H28.0753V51.4033H21.3867V44.6977H23.6137L23.6084 44.6924Z",
    fill: "#2965FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1864 24.5486H5.71192V26.7782H3.4834V22.3262H10.1807V24.5539L10.1864 24.5486Z",
    fill: "#2965FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4595 29.0184H48.2394V24.5576H46.0078V22.3223H50.4595V29.0184Z",
    fill: "#2965FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6616 24.5533V22.3252H19.1235V24.548H14.6562L14.6616 24.5533Z",
    fill: "#2965FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0004 33.507V31.2793H48.224V33.5017H45.9951L46.0004 33.507Z",
    fill: "#2965FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2441 35.752H50.4586V37.9702H48.2441V35.752Z",
    fill: "#2965FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3305 20.0764V17.8486H32.5541V20.0711H30.3252L30.3305 20.0764Z",
    fill: "#2965FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6149 40.2169H21.3867V37.9834H23.6149L23.6092 37.9785V40.2222L23.6149 40.2169Z",
    fill: "#2965FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0004 42.4602V40.2324H48.224V42.4549H45.9951L46.0004 42.4602Z",
    fill: "#2965FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7549 26.7911H45.983V29.0245H43.7549L43.7606 29.0298V26.7861L43.7549 26.7911Z",
    fill: "#2965FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5537 49.1641H30.3369V46.9492H32.5522L32.5537 49.1641Z",
    fill: "#2965FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0419 49.1689V51.3967H34.8184V49.1743H37.0473L37.0419 49.1689Z",
    fill: "#2965FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4586 51.4023H48.2441V49.1875H50.4586V51.4023Z",
    fill: "#2965FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5699 31.2626H30.3418V29.0391H32.5642V31.2679L32.5699 31.2626Z",
    fill: "#2965FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.6437 15.5881H7.9502V8.89648H14.6437V15.5881Z",
    fill: "#2965FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.2891 15.5832V8.8916H45.9807V15.5832H39.2891Z",
    fill: "#2965FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.9502 46.9205V40.2285H14.6418V46.9205H7.9502Z",
    fill: "#2965FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.a66ca084b3f7e397d0a13428eed2eb04.svg";
export { ForwardRef as ReactComponent };